import { CITY_LONGFORM_ENTRIES } from './cityData';
import { STADIUM_LONGFORM_ENTRIES } from './stadiumData';

function norm(s) {
  return (s || '').toLowerCase().trim();
}

function matchesEntry(entry, slug, name) {
  const s = norm(slug);
  const n = norm(name);
  if (entry.matchSlugs?.some((k) => k && s.includes(k))) return true;
  if (entry.matchNames?.some((k) => k && n.includes(k))) return true;
  return false;
}

/** @returns {object|null} */
export function getCityLongform(city) {
  if (!city) return null;
  const slug = city.slug || '';
  const name = city.name || '';
  const found = CITY_LONGFORM_ENTRIES.find((e) => matchesEntry(e, slug, name));
  return found || null;
}

/** @returns {object|null} */
export function getStadiumLongform(stadium) {
  if (!stadium) return null;
  const slug = stadium.slug || '';
  const name = stadium.name || '';
  const found = STADIUM_LONGFORM_ENTRIES.find((e) => matchesEntry(e, slug, name));
  return found || null;
}
